import React from 'react';
import Script from 'next/script';
import { getHTML } from '@util/common';
import { DestinationFaqListItem, getFaqItems } from '@components/destination/DestinationFAQ';
import { DestinationFaqItem } from '@state/slices/destination-faq';
import { useI18NextContext } from '@components/hooks';

export interface DestinationFaqMetaProps {
  path?: string;
  faqs: Array<DestinationFaqItem>;
}

export const DestinationFaqMeta = ({ faqs }: DestinationFaqMetaProps) => {
  const t: any = useI18NextContext();
  if (!faqs) {
    return null;
  }

  const faqItems = getFaqItems(faqs);

  const generateMainEntity = faqItems.map((item: DestinationFaqListItem) => {
    const title = item.title;
    const description = item.text;
    return {
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: description
      }
    };
  });

  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: generateMainEntity
  };

  return <Script type="application/ld+json" dangerouslySetInnerHTML={getHTML(JSON.stringify(t(data)))} />;
};
